import { render } from "./PublishForm.vue?vue&type=template&id=fa837da2&ts=true"
import script from "./PublishForm.vue?vue&type=script&lang=ts"
export * from "./PublishForm.vue?vue&type=script&lang=ts"

import "./PublishForm.vue?vue&type=style&index=0&id=fa837da2&lang=css"

import exportComponent from "/usr/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.11_vue@3.2.47_webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__